import {StoreStateShape} from '../store/storeStateTypes';

const cesiaCCCIntegrationFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) =>
    features?.CesiaCCCIntegration;

const integrationDispatchFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) =>
    features?.IntegrationDispatch;

const isWSConnectedSelector = ({commonUserDataReducer: {isWSConnected}}: StoreStateShape) => isWSConnected;

const isFfCallBellLogAvailableSelector = ({
    commonUserDataReducer: {
        features: {DisplayMissedCallsLog},
        permissions,
    },
}: StoreStateShape) => ({
    isFfCallBellLogAvailable: DisplayMissedCallsLog,
    permissions,
});

const brightStarIntegrationFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) =>
    features?.BrightStarIntegration;

const smartDraftFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) => features?.SmartDraft;

const addressBookFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) => features?.AddressBook;

const mergeServiceRequestsFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) =>
    features?.MergeServiceRequests;

const autoSurfaceVendorAlternateTimeRequestsFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) =>
    features?.AutoSurfaceVendorAlternateTimeRequests;

const multiStopAddressSupportFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) =>
    features?.MultiStopAddressSupport;

const lv1IntegrationFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) =>
    features?.LV1Integration;

const cesiaMciIntegrationFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) =>
    features?.CesiaMciIntegration;

const attachDocumentsToServiceConnectFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) =>
    features?.AttachPatientDocumentsToServiceConnect;

export {
    addressBookFeatureSelector,
    attachDocumentsToServiceConnectFeatureSelector,
    autoSurfaceVendorAlternateTimeRequestsFeatureSelector,
    brightStarIntegrationFeatureSelector,
    cesiaCCCIntegrationFeatureSelector,
    cesiaMciIntegrationFeatureSelector,
    integrationDispatchFeatureSelector,
    isFfCallBellLogAvailableSelector,
    isWSConnectedSelector,
    lv1IntegrationFeatureSelector,
    mergeServiceRequestsFeatureSelector,
    multiStopAddressSupportFeatureSelector,
    smartDraftFeatureSelector,
};
